// removed by extract-text-webpack-plugin
module.exports = {"carouselImages":"qempo_CarouselImages_carouselImages-3_8rthC","images":"qempo_CarouselImages_images-OdglovT","mobile":"qempo_CarouselImages_mobile-3tC-jaO","desktop":"qempo_CarouselImages_desktop-2jBi8uH","carousel":"qempo_CarouselImages_carousel-2cs71ZW","arrowLeft":"qempo_CarouselImages_arrowLeft-3q5eMqN","arrowRight":"qempo_CarouselImages_arrowRight-1OsSrOc"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/CarouselImages/CarouselImages.scss
// module id = 1978
// module chunks = 0